import { useInfiniteQuery } from '@tanstack/react-query';
import { useApiV2 } from '@/shared/api';
import { subscriptionsQueryOptions } from './subscriptions.query-options';

/**
 * 발전소 목록 + 구독 상태 query — `subscriptionsQueryOptions`(entity SSOT) 를 React 컨텍스트에 적용.
 * 서버 페이지네이션이라 `useInfiniteQuery` — 행은 `data.pages[].items`, 다음 페이지는 [더보기]
 * (`fetchNextPage`/`hasNextPage`). 구독·결제 도메인은 v2 (`useApiV2`).
 */
export function useSubscriptionsQuery() {
  const api = useApiV2();
  return useInfiniteQuery(subscriptionsQueryOptions(api));
}
